import { API_BASE_URL } from '../../../../api';
import React, { useState, useEffect,useContext } from "react";
import './CreateClient.style.scss';

import { AccountContext } from "../../../../Contexts/main.context";

const CreateClient = ({ onClose }) => {
     const { updateActiveOutlet,userAccounts,updateClientAccounts,updateReturnToLastLink } = useContext(AccountContext);


     const [formData, setFormData] = useState({
          companyName: "",
          email: "",
          phone: "",
          city: "",
          postal: "",
          address: "",
          contactPerson: "",
          accountManager: "",
          province: "",
     });

     // Disable background scroll and add ESC close support
     useEffect(() => {
          const handleKeyDown = (e) => {
               if (e.key === "Escape") {
                    updateActiveOutlet('Clients');
               }
          };

          document.body.style.overflow = 'hidden';
          window.addEventListener("keydown", handleKeyDown);

          return () => {
               document.body.style.overflow = 'auto';
               window.removeEventListener("keydown", handleKeyDown);
          };

     }, [onClose]);

     const closeThisBox = () => {
          updateActiveOutlet('Clients');
     };

     const handleChange = (e) => {
          const { name, value } = e.target;
          setFormData({ ...formData, [name]: value });
     };

     const handleSubmit = (e) => {
          e.preventDefault();

          const dataToSend = {
               ...formData,
               phone: formData.phone.trim() || "Not Set",
               status: "Active",
          };

  
          fetch(API_BASE_URL + 'data.php', {
               method: "POST",
               headers: {
                    "Content-Type": "application/json",
               },
               body: JSON.stringify({ script: "createClient", ...dataToSend }),
          })
               .then((response) => response.json())
               .then((data) => {
                    updateReturnToLastLink('Clients');
                    updateClientAccounts(data);
                    updateActiveOutlet('Clients');
               })
               .catch((error) => {
                    console.error("Error:", error);
               });
     };

     return (
          <div className="modal-overlay">
               <div
                    className="modal-container col-36 offset-6 bg-white border rounded p-4 shadow-lg"
                    onClick={(e) => e.stopPropagation()}
               >
                    <h3 className="text-center mt-2 mb-4">Create Client</h3>
                    <form onSubmit={handleSubmit}>
                         <div className="d-flex gap-2 mb-3">
                              <div className="col-16">
                                   <label className="form-label">Company Name<span className="text-danger superscript">*</span></label>
                                   <input
                                        type="text"
                                        name="companyName"
                                        value={formData.companyName}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                   />
                              </div>
                              <div className="col-12">
                                   <label className="form-label">Location - This is only for Main Accounts</label>
                                   <input
                                        type="text"
                                        name="companyName"
                                        value='Main Location'
                                        onChange={handleChange}
                                        className="form-control"
                                        readOnly
                                   />
                              </div>
                              <div className="flex-grow-1">
                                   <label className="form-label">Email</label>
                                   <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="form-control"
                                   />
                              </div>
                         </div>

                         <div className="d-flex gap-2 mb-3">
                              <div className="col-12">
                                   <label className="form-label">Phone<span className="text-danger superscript">*</span></label>
                                   <input
                                        type="text"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                   />
                              </div>
                              <div className="col-12">
                                   <label className="form-label">City<span className="text-danger superscript">*</span></label>
                                   <input
                                        type="text"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                   />
                              </div>
                              <div className="col-12">
                                   <label className="form-label">Postal/ZIP<span className="text-danger superscript">*</span></label>
                                   <input
                                        type="text"
                                        name="postal"
                                        value={formData.postal}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                   />
                              </div>
                              <div className="flex-grow-1">
                                   <label className="form-label">Province/State (2 Letters)<span className="text-danger superscript">*</span></label>
                                   <input
                                        type="text"
                                        name="province"
                                        value={formData.province}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                   />
                              </div>
                         </div>

                         <div className="d-flex gap-2 mb-3">
                              <div className="col-12">
                                   <label className="form-label">Address</label>
                                   <input
                                        type="text"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        className="form-control"
                                   />
                              </div>
                              <div className="col-12">
                                   <label className="form-label">Contact Person</label>
                                   <input
                                        type="text"
                                        name="contactPerson"
                                        value={formData.contactPerson}
                                        onChange={handleChange}
                                        className="form-control"
                                   />
                              </div>
                              <div className="col-12">
                                   <label className="form-label">Account Manager<span className="text-danger superscript">*</span></label>
                                   <select
                                        name="accountManager"
                                        value={formData.accountManager}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                   >
                                        <option value="" disabled>Select Account Manager</option>
                                        {userAccounts.map((userAccount) => (
                                             <option key={userAccount.ID} value={userAccount.ID}>
                                                  {userAccount.displayName}
                                             </option>
                                        ))}
                                   </select>
                              </div>
                         </div>

                         <div className="w-100 d-flex gap-3 justify-content-center">
                              <button type="button" className="btn btn-danger col-12" onClick={() => closeThisBox()}>
                                   Cancel
                              </button>
                              <button type="submit" className="btn btn-primary col-12">
                                   Save
                              </button>
                         </div>
                    </form>
               </div>
          </div>
     );
};

export default CreateClient;
